// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/agentes/services/agentesService.ts
//  Comunicação com os Agentes Operacionais (/api/agentes).
//  O loop de tool-use pode levar dezenas de segundos → timeout estendido.
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  AgenteResumo, AgenteTurnoResultado, AcaoProposta, AcaoExecutada, PropostaPendente,
} from '../types';

const BASE = '/api/agentes';
const TIMEOUT_LONGO = 180_000; // o orquestrador faz várias idas/voltas com o Claude

export const agentesService = {
  async listar(): Promise<AgenteResumo[]> {
    const { data } = await apiClient.get<AgenteResumo[]>(BASE);
    return data;
  },

  async processar(codigo: string, pedido: string): Promise<AgenteTurnoResultado> {
    const { data } = await apiClient.post<AgenteTurnoResultado>(
      `${BASE}/${codigo}/processar`,
      { pedido },
      { timeout: TIMEOUT_LONGO },
    );
    return data;
  },

  async confirmar(codigo: string, aprovadas: AcaoProposta[]): Promise<AgenteTurnoResultado> {
    const { data } = await apiClient.post<AgenteTurnoResultado>(
      `${BASE}/${codigo}/confirmar`,
      { aprovadas },
      { timeout: TIMEOUT_LONGO },
    );
    return data;
  },

  // ── Propostas pendentes persistidas (canal MCP e afins) ─────────────────────

  async listarPropostasPendentes(): Promise<PropostaPendente[]> {
    const { data } = await apiClient.get<PropostaPendente[]>(`${BASE}/propostas-pendentes`);
    return data;
  },

  async confirmarProposta(id: number): Promise<AcaoExecutada> {
    // executa a ação de escrita pelo caminho auditado → pode demorar
    const { data } = await apiClient.post<AcaoExecutada>(
      `${BASE}/propostas-pendentes/${id}/confirmar`,
      undefined,
      { timeout: TIMEOUT_LONGO },
    );
    return data;
  },

  async rejeitarProposta(id: number): Promise<void> {
    await apiClient.post(`${BASE}/propostas-pendentes/${id}/rejeitar`);
  },
};
